import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import API_BASE_URL from '../Config';

const LayoutContext = createContext();

export function useLayout() {
    return useContext(LayoutContext);
}

export function LayoutProvider({ children }) {
    const { token } = useAuth();
    const [title, setTitle] = useState('');
    const [actions, setActions] = useState([]);
    const [isCompact, setIsCompact] = useState(false);

    // Cooperative Configuration State
    const [coopName, setCoopName] = useState('Cooperativa');

    // MDI Tabs State
    const [tabs, setTabs] = useState([]);
    const [activeTabId, setActiveTabId] = useState(null);

    const toggleCompact = () => setIsCompact(prev => !prev);

    const refreshConfig = async () => {
        if (!token) return;
        try {
            const response = await fetch(`${API_BASE_URL}/configuracion-entidad`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                if (data.nombreCooperativa) {
                    setCoopName(data.nombreCooperativa);
                }
            }
        } catch (error) {
            console.error("Error fetching configuracion entidad:", error);
        }
    };

    // Fetch config on mount or when token changes
    useEffect(() => {
        refreshConfig();
    }, [token]);

    // Tab Management Functions
    const addTab = (tab) => {
        setTabs(prev => {
            const exists = prev.find(t => t.path === tab.path);
            if (!exists) {
                return [...prev, tab];
            }
            return prev;
        });
        setActiveTabId(tab.path);
    };

    const removeTab = (path) => {
        setTabs(prev => {
            const newTabs = prev.filter(t => t.path !== path);
            return newTabs;
        });
        // Note: The logic to select the next active tab will be handled in MainLayout or TabsBar
    };

    const value = {
        title, setTitle,
        actions, setActions,
        isCompact, toggleCompact,
        tabs, setTabs,
        activeTabId, setActiveTabId,
        addTab, removeTab,
        coopName, setCoopName,
        refreshConfig
    };

    return (
        <LayoutContext.Provider value={value}>
            {children}
        </LayoutContext.Provider>
    );
}
